import _extends from "@babel/runtime/helpers/esm/extends";
var buildGtmBannerEventData = function buildGtmBannerEventData(banner, isBannerCarousel, screenName, structure) {
  var additionalData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return _extends({}, banner, {
    contentType: isBannerCarousel ? 'banner_list' : 'banner',
    page: structure == null ? void 0 : structure.name,
    screenName: screenName || (structure == null ? void 0 : structure.name)
  }, additionalData);
};
export default buildGtmBannerEventData;